import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React from 'react';

export default function JsonDiffTable({ before, after }) {
  if (!before && !after) return <Typography>No data</Typography>;

  const allKeys = new Set([
    ...Object.keys(before || {}),
    ...Object.keys(after || {})
  ]);

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>
            <strong>Field</strong>
          </TableCell>
          <TableCell>
            <strong>Before</strong>
          </TableCell>
          <TableCell>
            <strong>After</strong>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {[...allKeys].map((key) => {
          const beforeVal = before?.[key];
          const afterVal = after?.[key];
          const changed =
            JSON.stringify(beforeVal) !== JSON.stringify(afterVal);
          return (
            <TableRow
              key={key}
              sx={{
                backgroundColor: changed ? 'rgba(255, 235, 59, 0.2)' : 'inherit'
              }}
            >
              <TableCell>{key}</TableCell>
              <TableCell>
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: 'monospace',
                    fontSize: '0.75rem',
                    wordBreak: 'break-all'
                  }}
                >
                  {beforeVal !== undefined ? JSON.stringify(beforeVal) : '-'}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: 'monospace',
                    fontSize: '0.75rem',
                    wordBreak: 'break-all'
                  }}
                >
                  {afterVal !== undefined ? JSON.stringify(afterVal) : '-'}
                </Typography>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
